throw new Error("This package has no default export. Use subpath imports like '@m3e/web/button'.");
